import {
  joinPathParts,
  resolveLocale,
  resolveLocaleRedirect,
} from '@sonos-inc/www-routing-helpers'
import { determineRedirectResponse } from '@sonos-inc/www-server'
import { logger } from '@sonos-inc/www-server/utils/logger'
import { GetStaticPaths, GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async (ctx) => {
  const commerceId = joinPathParts(ctx.params?.commerceid)
  const nextLocale = ctx.locale

  const localeRedirect = resolveLocaleRedirect(nextLocale, commerceId)
  if (localeRedirect) return localeRedirect

  const locale = resolveLocale(ctx.locale)

  const logPrefix = `Shop-Redirect-Route-/${locale}/shop/${commerceId}`

  try {
    return await determineRedirectResponse(locale, `shop/${commerceId}`)
  } catch (e) {
    logger.error(
      logPrefix,
      `Severe error - Unable to determine redirect response for ${locale}/shop/${commerceId}`,
      ctx.params,
      e
    )
    throw Error('Unresolvable redirect')
  }
}

export const getStaticPaths: GetStaticPaths = async () => ({
  fallback: 'blocking',
  paths: [],
})

export default function ShopPageResolver() {
  return
}
